export const FieldValue = {
    Undefined: 'undefined',
    Zero: '0',
};
